/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import Text from "./Text";

const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.125rem;
  font-size: calc(${({ theme }) => theme.fontSizes.p} * 0.75);
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  ${(props) => colorStyles[props.$color]}
`;

const colorStyles = {
  success: css`
    background: rgba(${({ theme }) => theme.colors.success.rgb}, 0.1);
    color: rgba(${({ theme }) => theme.colors.success.rgba});

    svg {
      stroke: rgba(${({ theme }) => theme.colors.success.rgba});
    }
  `,
  warning: css`
    background: rgba(${({ theme }) => theme.colors.warning.rgb}, 0.1);
    color: rgba(${({ theme }) => theme.colors.warning.rgba});

    svg {
      stroke: rgba(${({ theme }) => theme.colors.warning.rgba});
    }
  `,
  error: css`
    background: rgba(${({ theme }) => theme.colors.error.rgb}, 0.1);
    color: rgba(${({ theme }) => theme.colors.error.rgba});

    svg {
      stroke: rgba(${({ theme }) => theme.colors.error.rgba});
    }
  `,
  neutral: css`
    background: rgba(${({ theme }) => theme.colors.textSecondary.rgb}, 0.1);
    color: rgba(${({ theme }) => theme.colors.textSecondary.rgba});

    svg {
      stroke: rgba(${({ theme }) => theme.colors.textSecondary.rgba});
    }
  `,
  primary: css`
    background: rgba(${({ theme }) => theme.colors.accent.rgb}, 0.1);
    color: rgba(${({ theme }) => theme.colors.accent.rgba});

    svg {
      stroke: rgba(${({ theme }) => theme.colors.accent.rgba});
    }
  `,
  white: css`
    background: rgba(${({ theme }) => theme.colors.accentContrast.rgb}, 0.75);
    color: rgba(${({ theme }) => theme.colors.text.rgba});

    svg {
      fill: rgba(${({ theme }) => theme.colors.text.rgba});
    }
  `
};

const Badge = ({ title, icon, color, ...props }) => {
  return (
    <StyledBadge $color={color} {...props}>
      {icon}
      <Text color={color} size="small">
        {title}
      </Text>
    </StyledBadge>
  );
};

export default Badge;
